import { render, staticRenderFns } from "./TooltipWithTextInput.vue?vue&type=template&id=35bc8cbd&scoped=true&"
import script from "./TooltipWithTextInput.vue?vue&type=script&lang=ts&"
export * from "./TooltipWithTextInput.vue?vue&type=script&lang=ts&"
import style0 from "./TooltipWithTextInput.vue?vue&type=style&index=0&id=35bc8cbd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bc8cbd",
  null
  
)

export default component.exports